export default "__VITE_ASSET__DMNprqxB__"